<div class="fullcontainer" >
    <br />
    <br />
  
    <div class='titleContainer'>
      <h2 class='header' >Yard Trade Signoff</h2>
      <div>
        <button class='btn btn-secondary' routerLink='/weighbridge/yard-trade/'><i class="fas fa-plus"></i> New</button>&nbsp;
      </div>
    </div>
    <br />
    <br />

<button type='button' class='btn btn-primary' (click)='onSignOffButtonClicked()'>Sign off selected</button>
<br />
<br />
    <app-grid
  entity='yard-trade'
  [filters]='this.filters'
  [columns]='this.columns'
  [buttons]='this.buttons'
  [searchFilters]='this.searchFilters'
  [searchFields]='this.searchFields'
  [relationships]='["yardTradePricing", "grade"]'
  [checkboxSelector]='true'
  (checkboxSelected)='this.onCheckboxSelected($event)'
  [backgroundSetter]='this.getRowColor'
  ></app-grid>
  